export const endpoints = {
  REGION_SELECT: "/api/address/region",
  DISTRICT_SELECT: "/api/address/district",
  REFRESH: "/api/auth/refresh",
  LOGOUT: "/api/auth/logout",
  TAG_SELECT: "/api/tag/select",
}
